import { Avatar, Box, ButtonBase, Stack, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC } from "react";
import { getSvgDataUri } from "web_myplann/Shared/Utils/getSvgDataUri";

type Props = {
	icon?: string | React.ReactNode | null | undefined;
	iconText?: string;
	iconColor?: string;
	element: React.ReactNode;
	onClick: () => void;
};

export const CommonListItem: FC<Props> = ({
	icon,
	iconText,
	iconColor,
	element,
	onClick,
}) => {
	const theme = useTheme();

	const svgDataUri = getSvgDataUri(icon);

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			onClick={onClick}
			component={ButtonBase}
			textAlign="left"
		>
			<Stack gap={1.2} direction="row" alignItems="center" minWidth={0}>
				<Stack minWidth={80} alignItems="center" pl={1.6}>
					{svgDataUri ? (
						<Stack
							width={64}
							height={64}
							bgcolor={theme.palette.darkmodeText.white}
							borderRadius={theme.shape.pillRadius}
							alignItems="center"
							justifyContent="center"
							overflow="hidden"
						>
							<Box
								component="img"
								width={64}
								height={64}
								display="block"
								src={svgDataUri}
								alt={iconText}
							/>
						</Stack>
					) : icon ? (
						<Stack
							width={64}
							height={64}
							bgcolor={theme.palette.darkmodeText.white}
							alignItems="center"
							justifyContent="center"
							borderRadius={theme.shape.pillRadius}
							overflow="hidden"
						>
							{icon}
						</Stack>
					) : (
						<Avatar
							sx={{
								width: 64,
								height: 64,
								fontSize: 18,
								fontWeight: 600,
								borderRadius: theme.shape.pillRadius,
								backgroundColor: iconColor ?? theme.palette.common.black,
								color: theme.palette.darkmodeText.white,
							}}
						>
							{iconText}
						</Avatar>
					)}
				</Stack>
				<Box minWidth={0}>{element}</Box>
			</Stack>
			<Stack p={0.8}>
				<ChevronRight
					size={theme.iconSize.sm}
					color={theme.palette.primary.main}
				/>
			</Stack>
		</Stack>
	);
};
